import { render, staticRenderFns } from "./EditClientModal.vue?vue&type=template&id=7a32ab8d&"
import script from "./EditClientModal.vue?vue&type=script&lang=js&"
export * from "./EditClientModal.vue?vue&type=script&lang=js&"
import style0 from "./EditClientModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports